import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App/App.jsx";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store.js";
import { HelmetProvider } from "react-helmet-async";
import "./i18n"; // подключаем i18n
// import { setupAxios } from "./setupAxios.js"; // подключаем axios
import "./setupAxios.js";
import "./setupAxiosStudent.js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as Sentry from "@sentry/react";
// Sentry.init({
//   dsn: "https://7231875c18447eca4f4e2a1e4139b5eb@o4509796317921280.ingest.de.sentry.io/4509796338303056",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   release: "javascript-react",
//   sendDefaultPii: true,
//   environment: "production",
//   integrations: [Sentry.browserTracingIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/musicteacher4you\.com/],
//   // Logs
//   project: "javascript-react",
//   enableLogs: true,
//   // debug: true,
//   beforeSend(event) {
//     const sanitize = (s = "") =>
//       s.replace(/(token|code|signature)=([^&]+)/gi, "$1=[redacted]");
//     event.extra = {
//       ...(event.extra || {}),
//       path: typeof location !== "undefined" ? location.pathname : undefined,
//       search:
//         typeof location !== "undefined" ? sanitize(location.search) : undefined,
//       ua: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
//     };
//     return event;
//   },
// });
const CLIENT_ID =
  "1020721468893-0arm26e9u5s8ue0irlmvpp2gidtrok19.apps.googleusercontent.com";
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <Provider store={store}>
        <BrowserRouter>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </BrowserRouter>
      </Provider>
    </GoogleOAuthProvider>
  </StrictMode>
);
